import { CropItem, RangeSpan, RangeSpanType } from '../../api/utils/types'

export function formatGridLabel(rangeSpan: RangeSpan, cropItem: CropItem, position: number, pickerUnit = ''): string[] {

    const ticks = rangeSpan.type === RangeSpanType.DEPTH ? cropItem.ticksDepth : cropItem.ticksTime

    if (!rangeSpan.active || ticks === 0 || cropItem.tickStartPosition + position > rangeSpan.ticks) return []

    const start = rangeSpan.type === RangeSpanType.DEPTH ? cropItem.startSpanDepth : cropItem.startSpan

    const value = start + rangeSpan.interval * position

    switch (rangeSpan.type) {
        case RangeSpanType.DEPTH:            
            return [Math.round(value) + pickerUnit]
        case RangeSpanType.TIME:
            //TODO: SET TIMEZONE
            const date = new Date(value)
            return [date.toISOString().substring(0, 10), date.toISOString().substring(11, 19)]
    }
    return []
}
